module.exports = __webpack_public_path__ + "static/media/cybros-logo-i.44365a73.png";